import { AlertTriangle, FileText, Loader2 } from "lucide-react";
import { Checkbox } from "../ui/checkbox";

const Accept = ({ id, checked, onChange, children }) => (
  <label htmlFor={id} className="flex items-start gap-3 cursor-pointer rounded-xl p-4 border border-white/15 bg-black/30 hover:border-[#FFD200]/60 transition-colors">
    <Checkbox id={id} data-testid={id} checked={checked} onCheckedChange={(v) => onChange(v === true)}
      className="mt-0.5 h-5 w-5 border-[#FFD200] data-[state=checked]:bg-[#FFD200] data-[state=checked]:text-[#08080C]" />
    <span className="text-sm text-zinc-100 leading-relaxed">{children}</span>
  </label>
);

const Section = ({ s }) => (
  <section className="space-y-2">
    <h4 className="font-display font-bold text-sm md:text-base text-white">{s.title}</h4>
    {s.paragraphs.map((p, i) => <p key={i} className="text-sm text-zinc-300 leading-relaxed">{p}</p>)}
  </section>
);

export const StepContract = ({ contract, loading, acceptAccess, setAcceptAccess, acceptContract, setAcceptContract }) => {
  if (loading || !contract) {
    return <div className="flex items-center gap-3 text-zinc-300" data-testid="contract-loading"><Loader2 className="w-5 h-5 animate-spin" /> Preparando seu contrato…</div>;
  }
  const sections = Array.isArray(contract.sections) ? contract.sections : [];
  const access = sections.find((s) => s.highlight);
  return (
    <div className="space-y-6" data-testid="checkout-step-5-contract">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">
        <FileText className="w-4 h-4 text-[#FFD200]" /> Contrato de prestação de serviços · versão {contract.version}
      </p>
      <div data-lenis-prevent data-testid="contract-full-text"
        className="max-h-[420px] overflow-y-auto rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-7 space-y-5">
        <h3 className="font-display font-black text-lg text-white">CONTRATO DE PRESTAÇÃO DE SERVIÇOS — PLAY TOYS</h3>
        {sections.map((s) => (s.highlight ? (
          <div key={s.title} className="rounded-xl border-2 border-[#E8202A] bg-[#E8202A]/10 p-4"><Section s={s} /></div>
        ) : <Section key={s.title} s={s} />))}
      </div>
      {access && (
        <div className="rounded-2xl border-2 border-[#E8202A] bg-[#E8202A]/10 p-5 md:p-6 space-y-4" data-testid="contract-access-highlight">
          <h3 className="flex items-start gap-3 font-display font-black text-base md:text-lg text-white">
            <AlertTriangle className="w-6 h-6 text-[#FFD200] shrink-0" /> ATENÇÃO: CONDIÇÕES OBRIGATÓRIAS DE ACESSO E INSTALAÇÃO
          </h3>
          <div className="space-y-2">{access.paragraphs.map((p, i) => <p key={i} className="text-sm md:text-base text-zinc-100 leading-relaxed">{p}</p>)}</div>
          <Accept id="accept-access-checkbox" checked={acceptAccess} onChange={setAcceptAccess}>{contract.accept_access_text}</Accept>
        </div>
      )}
      <Accept id="accept-contract-checkbox" checked={acceptContract} onChange={setAcceptContract}>{contract.accept_contract_text}</Accept>
      <p className="text-xs text-zinc-400">O aceite do contrato não confirma o pagamento. Sua data só fica garantida após a confirmação do pagamento. Uma cópia em PDF ficará disponível ao final.</p>
    </div>
  );
};
